exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collector-layout {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  background-image: linear-gradient(to right, #7D16B4, #7D16B4, #7D16B4);\n  text-align: center;\n  color: white;\n}\n\n.collector-layout .collector-bank {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 0 6rem;\n  margin-top: 5rem;\n}\n\n.collector-layout .collector-bank__bank-logo {\n  width: 38rem;\n  height: 4rem;\n  margin-bottom: 3rem;\n}\n\n@media only screen and (min-width: 768px) {\n  .collector-layout {\n    min-height: 88.5vh;\n  }\n}\n\n", ""]);

// exports
